import * as Yup from 'yup'
import { ROLE } from '../../app/modules/auth'
import { INewTicket } from './NewTicket.types'

// Единая схема для всех ролей: обязательное поле зависит от выбранного режима (mode),
// а не от роли. «По реквизиту» → requisiteId, «По адаптеру» → paymentAdapterId.
export const NEW_TICKET_SCHEMA = Yup.object().shape({
  amount: Yup.string().required('Обязательное поле'),
  merchantToken: Yup.string().required('Обязательное поле'),
  mode: Yup.string().oneOf(['requisite', 'adapter']).required('Обязательное поле'),
  requisiteId: Yup.string().when('mode', {
    is: 'requisite',
    then: (schema) => schema.required('Обязательное поле'),
  }),
  paymentAdapterId: Yup.string().when('mode', {
    is: 'adapter',
    then: (schema) => schema.required('Обязательное поле'),
  }),
})

export const DEFAULT_NEW_TICKET_OBJ: INewTicket = {
  amount: '',
  mode: 'requisite',
  requisiteId: '',
  merchantToken: '',
  paymentAdapterId: '',
}

export const ROLES_FOR_NEW_TICKET = [
  ROLE.ROLE_ADMIN,
  ROLE.ROLE_CASHIER,
  ROLE.ROLE_SENIOR_CASHIER,
  ROLE.ROLE_MANAGER,
]
